import Link from 'next/link';
import styled from 'styled-components';
import { isFunction } from 'lodash';

interface IGridCellLink {
  children: React.ReactNode;
  onClick?: () => void;
  to: string;
}

export const GridCellLink = ({ children, onClick, to }: IGridCellLink) => {
  const handleOnClick = () => {
    if (isFunction(onClick)) {
      onClick();
    }
  };

  return (
    <Link href={to} passHref>
      <GridCellLink.Link onClick={handleOnClick}>{children}</GridCellLink.Link>
    </Link>
  );
};

GridCellLink.Link = styled.a`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;
